import { Map as ImmutableMap, List, OrderedMap } from 'immutable';
import { getProperty, getPropertyLabel, getReferenceLabel } from 'reporting-data/v2/dataset/datasetRecords';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'repo... Remove this comment to see the full error message
import { getPropertyFormatter } from 'reporting-visualizations/formatters/propertyFormatter';
import { DatawellCell, DatawellData, Directions, FieldOption } from './datawellRecords';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'repo... Remove this comment to see the full error message
import { LINKS_FIELD } from 'reporting-data/v2/dataset/constants';
import { fromMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { GLOBAL_NULL } from 'reporting-data/constants/defaultNullValues';
import { selectAndSortFieldValues } from '../../field/sort';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { isFormattableProperty } from '../../formatters/propertyFormatter';
import { hasReferences } from 'reporting-data/v2/dataset/datasetRecords';
import I18n from 'I18n';
//@ts-expect-error Untyped import
import { applyTransformations } from '../../transforms/applyTransformations';
import { getPropertyFormatterOverrides } from '../../formatters/propertyFormatterUtils';
import { getCompareValue } from './datawellUtils';
/**
 * @param {Dataset} dataset
 * @param {string} groupField
 * @param {Order?} order
 * @returns {List<Row>} rows
 */
const applyGroupOrder = (dataset, groupField, order) => {
  const data = dataset.data;
  if (!order) {
    return data;
  }
  if (groupField == null) {
    return data;
  }
  const definedOrder = selectAndSortFieldValues(dataset, groupField, order);
  return data.sortBy(row => {
    const groupValue = groupField && row.get(groupField);
    return definedOrder.indexOf(groupValue);
  });
};
const getValueOptionsForProperty = (property, valueFormattingOptions) => {
  const valueEncodingForPoint = valueFormattingOptions ? valueFormattingOptions.filter(option => {
    return option.column === property;
  }).first() : undefined;
  return valueEncodingForPoint && valueEncodingForPoint.options;
};
export const mapDatawellToViz = datawellVisualization => {
  const {
    data,
    layer,
    events: {
      getOnPointClick,
      getHeader,
      getBody
    } = {}
  } = datawellVisualization;
  const {
    dataset: datasetKey,
    compare: compareKey,
    direction,
    group,
    fields = List(),
    // List of metrics
    fieldOptions: maybeFieldOptions,
    order,
    transform,
    groupFormattingOptions,
    valueFormattingOptions,
    subtitleColumnMap,
    abbreviateNumbers
  } = layer;
  const dataProperties = data.getIn(['primary', 'properties']);
  const fieldOptions = maybeFieldOptions || fields.map(field => FieldOption({
    field,
    dataset: datasetKey,
    subtitleField: subtitleColumnMap === null || subtitleColumnMap === void 0 ? void 0 : subtitleColumnMap.get(field)
  }));
  const getDataset = key => applyTransformations(data.get(key), transform);
  const primaryDataset = getDataset(datasetKey);
  const rows = primaryDataset === null || primaryDataset === void 0 ? void 0 : primaryDataset.get('data');
  const getInverseDeltas = (properties = ImmutableMap(), property) => properties.getIn([property, 'inverseDeltas'], false) || properties.getIn([property, 'format', 'inverseDeltas'], false);
  const events = {
    getOnPointClick(cell) {
      return getOnPointClick ? getOnPointClick({
        cell,
        layer,
        dataset: data.get(cell.get('dataset') || datasetKey)
      }) : undefined;
    },
    getHeader,
    getBody
  };
  if (rows !== null && rows !== void 0 && rows.isEmpty()) {
    return DatawellData({
      data: List(),
      events
    });
  }
  const mappedData = direction === Directions.horizontal ? fieldOptions.reduce((acc, fieldOption) => {
    const field = fieldOption.field;
    const dataset = getDataset(fieldOption.dataset || datasetKey);
    if (dataset === undefined) {
      return acc;
    }
    return acc.set(fieldOption, (dataset.get('data').first() || ImmutableMap()).get(field));
  }, OrderedMap()).map((value, fieldOption) => {
    const property = fieldOption.get('field');
    const maybeSubtitleField = fieldOption.get('subtitleField');
    const maybeSubtitleProperty = maybeSubtitleField === null || maybeSubtitleField === void 0 ? void 0 : maybeSubtitleField.get('metric');
    const maybeSubtitleLabelOverride = maybeSubtitleField === null || maybeSubtitleField === void 0 ? void 0 : maybeSubtitleField.get('propertyLabel');
    const dataset = getDataset(fieldOption.get('dataset') || datasetKey);
    const row = dataset.get('data').first();
    const maybeSubtitleValue = maybeSubtitleProperty && row.get(maybeSubtitleProperty);
    const valueOptionsForPoint = getValueOptionsForProperty(property, valueFormattingOptions);
    const maybeValueOptionsForSubtitle = maybeSubtitleProperty && getValueOptionsForProperty(maybeSubtitleProperty, valueFormattingOptions);
    const maybeFormattableProperty = getProperty(dataset, property);
    const maybeFormattableSubtitleProperty = maybeSubtitleProperty && getProperty(dataset, maybeSubtitleProperty);
    const formattableProperty = isFormattableProperty(maybeFormattableProperty) && valueOptionsForPoint ? maybeFormattableProperty.set('formattingType', valueOptionsForPoint.getIn(['format', 'type'])).set('formattingObject', valueOptionsForPoint.get('format')) : maybeFormattableProperty;
    const formattablePropertyFormatterOverrides = getPropertyFormatterOverrides(formattableProperty === null || formattableProperty === void 0 ? void 0 : formattableProperty.get('type'), abbreviateNumbers);
    const maybeFormattableSubtitle = maybeFormattableSubtitleProperty && isFormattableProperty(maybeFormattableSubtitleProperty) && maybeValueOptionsForSubtitle ? maybeFormattableSubtitleProperty.set('formattingType', maybeValueOptionsForSubtitle.getIn(['format', 'type'])).set('formattingObject', maybeValueOptionsForSubtitle.get('format')) : maybeFormattableSubtitleProperty;
    const formattableSubtitleFormatterOverrides = getPropertyFormatterOverrides(maybeFormattableSubtitle === null || maybeFormattableSubtitle === void 0 ? void 0 : maybeFormattableSubtitle.get('type'), abbreviateNumbers);
    const tooltip = valueOptionsForPoint && valueOptionsForPoint.has('tooltipI18nKey') ? I18n.text(valueOptionsForPoint.get('tooltipI18nKey')) : undefined;
    const cellSubtitleValues = maybeSubtitleProperty && maybeFormattableSubtitle && maybeSubtitleValue ? {
      subtitleLabel: maybeSubtitleLabelOverride || getPropertyLabel(dataset, maybeSubtitleProperty),
      subtitleValue: maybeSubtitleValue,
      subtitleValueLabel: getPropertyFormatter(maybeFormattableSubtitle, formattableSubtitleFormatterOverrides)(maybeSubtitleValue)
    } : {};
    const datasetName = fieldOption.get('dataset');
    const compare = datasetName ? getCompareValue({
      datasetName,
      fieldName: property,
      getDataset,
      // abbreviate options for number display in the tooltip
      abbreviateNumberIfPossible: abbreviateNumbers
    }) : undefined;
    return DatawellCell(Object.assign({}, cellSubtitleValues, {
      label: getPropertyLabel(dataset, property),
      value,
      valueLabel: getPropertyFormatter(formattableProperty, formattablePropertyFormatterOverrides)(value),
      tooltip,
      field: property,
      dataset: fieldOption.dataset || datasetKey,
      property: fromMetricKey(property).property,
      row,
      layer,
      inverseDeltas: getInverseDeltas(dataProperties, property),
      compare: (compare === null || compare === void 0 ? void 0 : compare.label) && (compare === null || compare === void 0 ? void 0 : compare.value),
      compareValueLabel: compare === null || compare === void 0 ? void 0 : compare.label,
      summary: row && row.map((rowElement, rowKey) => {
        const valueOptionsForRow = getValueOptionsForProperty(rowKey, valueFormattingOptions);
        const maybeFormattableRowProperty = getProperty(dataset, rowKey);
        const formattableRowProperty = isFormattableProperty(maybeFormattableRowProperty) && valueOptionsForRow ? maybeFormattableRowProperty.set('formattingType', valueOptionsForRow.getIn(['format', 'type'])).set('formattingObject', valueOptionsForRow.get('format')) : maybeFormattableRowProperty;
        const formattableRowPropertyFormatterOverrides = getPropertyFormatterOverrides(formattableRowProperty === null || formattableRowProperty === void 0 ? void 0 : formattableRowProperty.get('type'), abbreviateNumbers);
        return ImmutableMap({
          raw: rowElement,
          formatted: getPropertyFormatter(formattableRowProperty, formattableRowPropertyFormatterOverrides)(rowElement)
        });
      })
    }));
  }).toList() : applyGroupOrder(primaryDataset, group, order).map(row => {
    const field = fields.first();
    const value = row.get(field);
    const valueOptionsForPoint = getValueOptionsForProperty(field, valueFormattingOptions);
    const maybeFormattableProperty = getProperty(primaryDataset, field);
    const formattableProperty = isFormattableProperty(maybeFormattableProperty) && valueOptionsForPoint ? maybeFormattableProperty.set('formattingType', valueOptionsForPoint.getIn(['format', 'type'])).set('formattingObject', valueOptionsForPoint.get('format')) : maybeFormattableProperty;
    const formattablePropertyFormatterOverrides = getPropertyFormatterOverrides(formattableProperty === null || formattableProperty === void 0 ? void 0 : formattableProperty.get('type'), abbreviateNumbers);
    const maybeFormattableGroupProperty = group ? getProperty(primaryDataset, group) : undefined;
    const formattableGroupProperty = isFormattableProperty(maybeFormattableGroupProperty) && groupFormattingOptions ? maybeFormattableGroupProperty.set('formattingType', groupFormattingOptions.getIn(['format', 'type'])).set('formattingObject', groupFormattingOptions.get('format')) : undefined;
    const formattableGroupPropertyFormatterOverrides = getPropertyFormatterOverrides(formattableGroupProperty === null || formattableGroupProperty === void 0 ? void 0 : formattableGroupProperty.get('type'), abbreviateNumbers);
    const propertyUsesReferences = group && hasReferences(primaryDataset, field, row.get(group));
    const groupLabel = group ? propertyUsesReferences || !formattableGroupProperty ? getReferenceLabel(primaryDataset, group, row.get(group)) : getPropertyFormatter(formattableGroupProperty, formattableGroupPropertyFormatterOverrides)(row.get(group)) : undefined;
    return DatawellCell({
      label: `${groupLabel}`,
      row,
      value,
      valueLabel: getPropertyFormatter(formattableProperty, formattablePropertyFormatterOverrides)(value),
      field,
      dataset: datasetKey,
      property: fromMetricKey(field).property,
      layer,
      inverseDeltas: getInverseDeltas(dataProperties, field),
      summary: row && row.map((rowElement, rowKey) => {
        const valueOptionsForRow = getValueOptionsForProperty(rowKey, valueFormattingOptions);
        const maybeFormattableRowProperty = getProperty(primaryDataset, rowKey);
        const formattableRowProperty = isFormattableProperty(maybeFormattableRowProperty) && valueOptionsForRow ? maybeFormattableRowProperty.set('formattingType', valueOptionsForRow.getIn(['format', 'type'])).set('formattingObject', valueOptionsForRow.get('format')) : maybeFormattableRowProperty;
        const formattableRowPropertyFormatterOverrides = getPropertyFormatterOverrides(formattableRowProperty === null || formattableRowProperty === void 0 ? void 0 : formattableRowProperty.get('type'), abbreviateNumbers);
        return ImmutableMap({
          raw: rowElement,
          formatted: getPropertyFormatter(formattableRowProperty, formattableRowPropertyFormatterOverrides)(rowElement)
        });
      })
    });
  });
  const compareDataset = compareKey && data.get(compareKey);
  const datawellMappedData = compareKey && compareDataset ? mappedData.map((cell, index) => {
    const field = cell.get('field');
    const cellValue = cell.get('value');
    const maybeCellGroup = cell.getIn(['row', group]);
    let compareValue;
    if (direction === Directions.horizontal) {
      compareValue = compareDataset.getIn(['data', 0, field]);
    } else {
      const compareData = compareDataset.get('data');
      const comparisonValue = cellValue === null ? ImmutableMap({
        [field]: null
      }) : compareData.find(comparisonRow => group !== undefined && comparisonRow.get(group) === maybeCellGroup) || compareData.get(index) || ImmutableMap({
        [field]: GLOBAL_NULL
      });
      compareValue = comparisonValue.get(field);
    }
    const maybeFormattableProperty = getProperty(compareDataset, field);
    const compareValueLabel = getPropertyFormatter(maybeFormattableProperty)(compareValue);
    return cell.set('compare', compareValue).set('compareValueLabel', compareValueLabel || compareValue);
  }).toList() : mappedData.toList();
  const filteredData = datawellMappedData.filterNot(dataRow => dataRow.get('field') === LINKS_FIELD).toList();
  return DatawellData({
    data: filteredData,
    events
  });
};